// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39yZn","label":"styles_label__1MDHh"};